import type { FC } from 'react'

import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SignupButton from '@segment/matcha/recipes/SignupButton'

import FormSubmitAction from '@segment/templates/FormSubmitAction'
import LogoTiles from '@segment/templates/LogoTiles'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `What's next?`,
  description: `Start connecting your data with Twilio Segment`,
  completed: {
    heading: `Congratulations!`,
    description: `You’ve completed all lessons in the Twilio Segment Analytics Academy.`,
  },
}

const WhatsNext: FC = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <StyledSection variant="centered">
        <Section.Copy>
          <CopyTextBase centered={true}>
            <CourseCompleted
              status="success"
              heading={copy.completed.heading}
              description={copy.completed.description}
            />
            <CopyTextBase centered={true}>
              <CopyText.Heading tag="h3" variant="h2">
                {copy.heading}
              </CopyText.Heading>
              <CopyText.Description tag="p">{copy.description}</CopyText.Description>
            </CopyTextBase>
          </CopyTextBase>
          <Buttons>
            <Button size="large" color="primary" variant="outlined" tag="a" href={getAbsoluteUrl(`/demo/`, pageConfig)}>
              Get a demo
            </Button>
            <SignupButton tag="a" iconEnd={ChevronRightIcon}>
              Create a free account
            </SignupButton>
          </Buttons>
        </Section.Copy>
      </StyledSection>
      <LogoTiles />
    </Wrapper>
  )
}

export default WhatsNext

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
  overflow-y: auto;
  overflow-x: hidden;
`

const StyledSection = styled(SectionBase)`
  max-width: 800px;

  ${Section.Wrapper} {
    gap: 0;
  }
`

const CourseCompleted = styled(FormSubmitAction)`
  margin-bottom: 50px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    margin-bottom: 120px;
  }
`

const Buttons = styled.div`
  margin-top: 40px;
  display: grid;
  gap: 24px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    margin-left: 40px;
    margin-right: 40px;
    grid-template-columns: 1fr 1fr;
  }
`
